import { createSlice } from '@reduxjs/toolkit';
import { asyncIsFulfilled, asyncIsPending, asyncIsRejected } from '../asyncConfig';
import { getAllPromotions, getPromoFulfilled, addPromo, getAppliedPromos, applyPromotion } from './promotion_thunk'

const initialState = {
  promotions: [],
  status: '',
  message: ''
}

export const promoSlice = createSlice({
  name: 'promotions',
  initialState,
  reducers: {
    clearPromoState: (state) => {
      state.status = '';
      state.message = ''
    },
  },
  extraReducers: {
    [addPromo.pending]: asyncIsPending,
    [addPromo.rejected]: asyncIsRejected,
    [addPromo.fulfilled]: asyncIsFulfilled,
    [applyPromotion.pending]: asyncIsPending,
    [applyPromotion.rejected]: asyncIsRejected,
    [applyPromotion.fulfilled]: asyncIsFulfilled,
    [getAllPromotions.pending]: asyncIsPending,
    [getAllPromotions.rejected]: asyncIsRejected,
    [getAllPromotions.fulfilled]: getPromoFulfilled,
    [getAppliedPromos.pending]: asyncIsPending,
    [getAppliedPromos.rejected]: asyncIsRejected,
    [getAppliedPromos.fulfilled]: getPromoFulfilled,
  }
});

export const { clearPromoState } = promoSlice.actions;
export default promoSlice.reducer;